import { Component, Input, OnInit } from '@angular/core';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { IconType } from '@shared/utils/icons';

@Component({
    selector: 'shared-ui-inputs-password-info',
    templateUrl: './password-info.component.html',
    styleUrls: ['./password-info.component.css'],
    standalone: false
})
export class PasswordInfoComponent implements OnInit {
  @Input() placement: Placement = 'top';

  iconType = IconType;

  constructor() {}

  ngOnInit(): void {}
}
